import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

// import our fonts
import "@fontsource/ibm-plex-sans";
import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/700.css";

// 1. import `ChakraProvider` component
import { ChakraProvider } from "@chakra-ui/react";

import theme from "./theme/theme";
import { OpenAPI } from "./api/core/OpenAPI";
//import { configureFtsoWeb3 } from "@flare.space/ftso-web3";
import { createBrowserRouter, RouterProvider, redirect } from "react-router-dom";
import UnavailablePage from "./pages/UnavailablePage/UnavailablePage";

// IMPORTANT!
// NOTE: Legacy App.tsx (Distribution Simulator) is no longer used.
// The feature was sunset and replaced with the UnavailablePage route.


const router = createBrowserRouter(
  [
    {
      path: "/", 
      loader: () => redirect("/unavailable"),
    },
    {
      path: "/unavailable",
      element: <UnavailablePage />,
    },
    {
      path: "*",
      loader: () => redirect("/unavailable"),
    },
  ],
  {
    basename: "/dapp/distribution", 
  }
);


OpenAPI.BASE = import.meta.env.VITE_HISTORY_API ? import.meta.env.VITE_HISTORY_API : "https://flare.space/api/history";

// This initialization is disabled because App.tsx is not currently used.
// Uncomment if the Distribution Simulator is re-enabled.
// configureFtsoWeb3(import.meta.env.VITE_RPC_VERSION === "Test" ? "Test" : "Production");
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
